import React from 'react'
import { Link } from 'react-router-dom'


function Sideone() {
  return (
    <>
        <section id="custom_html-5" className="widget_text widget widget_custom_html">
        <img src="../../assets/img/blog/aa.png" alt="" />
                <a className="widget-title" href="https://www.orissapost.com/good-oral-health-sine-qua-non-for-staying-fit-sauvik-singha/" >Good oral health sine qua non for staying fit: Sauvik Singha</a>
                <div className="textwidget custom-html-widget">
                <div className="widget-social">
                    <a href="https://www.orissapost.com/good-oral-health-sine-qua-non-for-staying-fit-sauvik-singha/" target='_blank'><i class="fa fa-link" aria-hidden="true"></i></a>
                </div>
                </div>
        </section>
        <section id="custom_html-5" className="widget_text widget widget_custom_html">
                <h2 className="widget-title">Follow Us</h2>
                <div className="textwidget custom-html-widget">
                <div className="widget-social">
                    <a href="https://www.facebook.com/write2ismile/" target='_blank'><i className="fab fa-facebook-f" /></a>
                    <a href="https://www.instagram.com/ismiledent/" target='_blank'><i className="fab fa-instagram" /></a>
                </div>
                </div>
        </section>
    </>
  )
}

export default Sideone